var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import format from 'date-fns/format';
import { MONTHS, SHORT_MONTHS } from '../constants/common';
var getIntakeOptions = function (props) {
    var currentYear = Number(format(new Date(), 'yyyy'));
    var intakeOptions = [];
    var startYear = (props === null || props === void 0 ? void 0 : props.startYear) || currentYear - 2;
    var startMonth = (props === null || props === void 0 ? void 0 : props.startMonth) || 0;
    var _loop_1 = function (year) {
        var options = [];
        var months = (props === null || props === void 0 ? void 0 : props.monthShort) ? SHORT_MONTHS : MONTHS;
        months.forEach(function (month, index) {
            if (year > startYear || index >= startMonth) {
                options.push({
                    label: "".concat(month, " ").concat(year),
                    value: "".concat(((props === null || props === void 0 ? void 0 : props.monthCharLength) ? month.substring(0, props.monthCharLength) : month).toUpperCase(), "_").concat(year)
                });
            }
        });
        intakeOptions.push.apply(intakeOptions, __spreadArray([], __read(__spreadArray([], __read(options), false)), false));
    };
    for (var year = startYear; year < currentYear + 3; year++) {
        _loop_1(year);
    }
    return intakeOptions;
};
export var getGroupedIntakes = function (intakeOptions) {
    var _a, _b;
    if (intakeOptions === void 0) { intakeOptions = {}; }
    var startYear = Number(format(new Date(), 'yyyy'));
    startYear = (_a = intakeOptions === null || intakeOptions === void 0 ? void 0 : intakeOptions.startYear) !== null && _a !== void 0 ? _a : startYear;
    intakeOptions.startYear = startYear;
    intakeOptions.startMonth = (_b = intakeOptions.startMonth) !== null && _b !== void 0 ? _b : 0;
    var intakes = getIntakeOptions(intakeOptions);
    var groupedIntakes = [];
    var div = 0;
    for (var i = 1; i < intakes.length; i += 12) {
        var group = {};
        group.title = "".concat(startYear, " Intakes");
        group.intakeGroups = [];
        if (startYear > intakeOptions.startYear || intakeOptions.startMonth < 3) {
            group.intakeGroups.push({
                title: "Autumn ".concat(startYear, " (Dec ").concat(startYear - 1, " to Mar ").concat(startYear, ")"),
                months: intakes.slice(div, (div += 4))
            });
        }
        if (startYear > intakeOptions.startYear || (intakeOptions === null || intakeOptions === void 0 ? void 0 : intakeOptions.startMonth) < 7) {
            group.intakeGroups.push({
                title: "Summer ".concat(startYear, " (Apr ").concat(startYear, " to July ").concat(startYear, ")"),
                months: intakes.slice(div, (div += 4))
            });
        }
        if (startYear > intakeOptions.startYear || (intakeOptions === null || intakeOptions === void 0 ? void 0 : intakeOptions.startMonth) < 11) {
            group.intakeGroups.push({
                title: "Fall ".concat(startYear, " (Aug ").concat(startYear, " to Nov ").concat(startYear, ")"),
                months: intakes.slice(div, (div += 4))
            });
        }
        startYear++;
        groupedIntakes.push(group);
    }
    return { intakes: intakes, groupedIntakes: groupedIntakes };
};
export var getWeatherIntakeStartMonthFromToday = function () {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth();
    var currentYear = currentDate.getFullYear();
    if (currentMonth <= 2) {
        return {
            month: 11,
            year: currentYear - 1
        };
    }
    else if (currentMonth <= 6) {
        return {
            month: 3,
            year: currentYear
        };
    }
    return {
        month: 7,
        year: currentYear
    };
};
export var getIntakeMonthGroups = function () {
    return [
        { label: 'Apr to Jul', value: MONTHS.slice(3, 7).map(function (month) { return month.toUpperCase(); }) },
        { label: 'Aug to Nov', value: MONTHS.slice(7, 11).map(function (month) { return month.toUpperCase(); }) },
        {
            label: 'Dec to Mar',
            value: MONTHS.slice(0, 3)
                .concat(MONTHS.slice(11))
                .map(function (month) { return month.toUpperCase(); })
        }
    ];
};
//# sourceMappingURL=intakes.js.map